import request from '@/util/request'

export function listType() {
  return request({
    url: 'receiptType/list',
    method: 'get'
  })
}

export function addType(data) {
  return request({
    url: 'receiptType/add',
    method: 'post',
    data
  })
}

export function modifyType(data) {
  return request({
    url: 'receiptType/modify',
    method: 'post',
    data
  })
}

export function deleteType(id) {
  return request({
    url: 'receiptType/delete',
    method: 'get',
    params: {
      id
    }
  })
}
